<template>
  <div class="columns is-multiline is-main-content is-marginless is-paddingless"
       v-if="newCritereRecherche">
    <div class="column is-12 pdb-0"
         :class="[{'hauteur-haut-brief-filtre': errors.length === 0},
      {'hauteur-haut-brief-filtre-errors': errors.length > 0}]">
      <div class="column is-12 mgt-5px">
        <a @click="$emit('toggleFiltre')">
          <b-icon class="icon is-pulled-right has-text-icon-more" icon="close"></b-icon>
        </a>
        <span class="has-text-weight-bold is-size-4">
          {{ $t('listeContrat.filtre.title') }}
        </span>
      </div>
      <div class="column is-12 pdt-0">
        <span class="has-text-icon-more is-size-7">
          {{ $t('listeContrat.filtre.sousTitle') }}
        </span>
      </div>
      <div class="column is-12" v-if="hasError">
        <error-msg-component :messages="errors"
                             :error="hasError"
                             :title="'general.problemOccurred'"
                             :withEmplyFields="true"
                             @close="closeErrorMsg"/>
      </div>
    </div>
    <div class="column is-12 overflow-auto is-marginless"
         :class="[{'hauteur-brief-filtre': errors.length === 0},
           {'hauteur-brief-filtre-errors': errors.length > 0}]">
      <div class="column is-12 pdb-0 mgt-10px">
        <b-field :label="$t('listeContrat.filtre.codeBail')">
          <qd-taginput
            v-model="newCritereRecherche.codes"
            type="is-primary">
          </qd-taginput>
        </b-field>
      </div>
      <div class="column is-12 pdb-0">
        <b-field :label="$t('listeContrat.filtre.codeFace')">
          <qd-taginput
            v-model="newCritereRecherche.codesFace"
            type="is-primary">
          </qd-taginput>
        </b-field>
      </div>
      <div class="column is-12 pdb-0">
        <b-field :label="$t('listeContrat.filtre.natureContrat')">
          <qd-taginput
            v-if="natureTags"
            v-model="natureSelected"
            :data="natureTags"
            @typing="getFilteredNatureTags"
            @input="getNatureTag"
            type="is-primary"
            icon="magnify"
            field="libelle"
            autocomplete
            open-on-focus>
          </qd-taginput>
        </b-field>
      </div>
      <div class="column is-12 pdb-0">
        <libelle-tag-input
                      :label="$t('listeContrat.filtre.typeContrat')"
                      :items="constantes.LISTE_TYPE_CONTRAT"
                      v-model="typeContratSelected">
        </libelle-tag-input>
      </div>
      <div class="column is-12 pdb-0">
        <libelle-tag-input
                      :label="$t('listeContrat.filtre.etat')"
                      :items="constantes.LISTE_ETAT_CONTRAT"
                      v-model="etatContratSelected">
        </libelle-tag-input>
      </div>
      <div class="column is-12 pdb-0" v-if="!hideBailleur">
        <b-field :label="$t('listeContrat.filtre.bailleur')">
          <qd-taginput
            v-model="bailleurSelected"
            icon="magnify"
            :data="filteredBailleur"
            autocomplete
            type="is-primary"
            :loading="isFetching"
            field="nomCommercial"
            @typing="getFilteredBailleur">
            <template slot="empty">
              <div v-if="!isFetching">
                {{$t('listeOrdreTravailAffichage.filtre.actions.noResult')}}
              </div>
              <div v-else>{{$t('listeOrdreTravailAffichage.filtre.actions.search')}}</div>
            </template>
          </qd-taginput>
        </b-field>
      </div>
      <div class="column is-12 pdb-0">
        <b-field :label="$t('listeContrat.filtre.motifDeBlocage')">
          <qd-taginput v-if="motifTags"
            v-model="motifSelected"
            :data="motifTags"
            type="is-primary"
            icon="magnify"
            autocomplete
            open-on-focus
            field="libelle"
            @typing="getFilteredMotifTags"
            @input="getMotifTag">
          </qd-taginput>
        </b-field>
      </div>
      <div class="column is-12 pdb-0">
        <b-field :label="$t('listeContrat.filtre.blocagePaiement')">
          <b-select v-model="newCritereRecherche.blocagePaiement">
              <option :value="null"></option>
              <option :value="true"> {{ $t('general.oui') }}
              </option>
              <option :value="false"> {{ $t('general.non') }}
              </option>
            </b-select>
        </b-field>
      </div>
      <div class="column is-12 pdb-0">
        <b-field :label="$t('listeContrat.filtre.periodeDateContrat')">
          <div class="columns is-vcentered" >
            <b-datepicker show-week-number
                          class="column"
                          icon="calendar-today"
                          :editable="true"
                          v-model="newCritereRecherche.periodeContrats.dateDebut"
                          :nearby-selectable-month-days="true">
            </b-datepicker>
            <span class="column is-1">{{$t('listeContrat.filtre.au')}}</span>
            <b-datepicker show-week-number
                          class="column"
                          icon="calendar-today"
                          :editable="true"
                          v-model="newCritereRecherche.periodeContrats.dateFin"
                          position="is-bottom-left"
                          :nearby-selectable-month-days="true">
            </b-datepicker>
          </div>
        </b-field>
      </div>
      <div class="column is-12 pdb-0">
        <b-field :label="$t('listeContrat.filtre.datePreavis')">
          <div class="columns is-vcentered" >
            <b-datepicker show-week-number
                          class="column"
                          icon="calendar-today"
                          :editable="true"
                          v-model="newCritereRecherche.datePreavis.dateDebut"
                          :nearby-selectable-month-days="true">
            </b-datepicker>
            <span class="column is-1">{{$t('listeContrat.filtre.au')}}</span>
            <b-datepicker show-week-number
                          class="column"
                          icon="calendar-today"
                          :editable="true"
                          v-model="newCritereRecherche.datePreavis.dateFin"
                          position="is-bottom-left"
                          :nearby-selectable-month-days="true">
            </b-datepicker>
          </div>
        </b-field>
      </div>
      <div class="column is-12 pdb-0 mgt-10px">
        <user-tag-input
                      :label="$t('listeContrat.filtre.responsableBail')"
                      v-model="responsableBailSelected"
                      :items="listeResponsablesBail">
        </user-tag-input>
      </div>
      <div class="column is-12 pdb-0">
        <query-fournisseur-tag-input
          v-model="tiersDemarcheurSelected"
          :societeActiveId="societeActiveId"
          :label="$t('listeContrat.filtre.demarcheur')"
          :sousType="[constantes.TIERS_SOUS_TYPE_DEMARCHEUR]">
        </query-fournisseur-tag-input>
      </div>
      <div class="column is-12 pdb-0" v-if="moduleSecteurActive">
        <secteur-tag-input
          v-model="secteursSelected"
          :label="$t('listeContrat.filtre.secteurs')"
          :critere="(el) => el.type === constantes.PATRIMOINE"
          :disabled="secteurCurrentUser.length > 0">
        </secteur-tag-input>
      </div>
      <div class="column is-12 pdb-0" v-if="moduleSecteurActive">
        <b-field :label="$t('listeContrat.filtre.hasSecteur')">
          <b-select v-model="newCritereRecherche.hasSecteur">
            <option :value="null"></option>
            <option :value="true"> {{ $t('general.oui') }} </option>
            <option :value="false"> {{ $t('general.non') }} </option>
          </b-select>
        </b-field>
      </div>
      <div class="column is-12 pdb-0">
        <b-field :label="$t('listeContrat.filtre.reconductible')">
          <b-select v-model="newCritereRecherche.reconductible">
              <option :value="null"></option>
              <option :value="true"> {{ $t('general.oui') }}
              </option>
              <option :value="false"> {{ $t('general.non') }}
              </option>
            </b-select>
        </b-field>
      </div>
      <div class="column is-12 pdb-0" v-if="agencesSelectionnees.length > 1">
        <agence-tag-input
                      :label="$t('listeContrat.filtre.agence')"
                      :items="agencesSelectionnees"
                      v-model="newCritereRecherche.agencesId">
        </agence-tag-input>
      </div>
      <div class="column is-12 pdb-0">
        <b-field :label="$t('listeContrat.filtre.estIndexe')">
          <b-select v-model="newCritereRecherche.estIndexe">
              <option :value="null"></option>
              <option :value="true"> {{ $t('general.oui') }}
              </option>
              <option :value="false"> {{ $t('general.non') }}
              </option>
            </b-select>
        </b-field>
      </div>
      <div class="column is-12 pdb-0">
        <b-field :label="$t('listeContrat.filtre.paiementSurFacture')">
          <b-select v-model="newCritereRecherche.paiementSurFacture">
              <option :value="null"></option>
              <option :value="true"> {{ $t('general.oui') }}
              </option>
              <option :value="false"> {{ $t('general.non') }}
              </option>
            </b-select>
        </b-field>
      </div>
      <div class="column is-12 pdb-0">
        <libelle-tag-input
                      :label="$t('listeContrat.filtre.etatRenouvellement')"
                      :items="constantes.LISTE_ETAT_RENOUVELLEMENT"
                      v-model="etatRenouvellementSelected">
        </libelle-tag-input>
      </div>
      <div class="column is-12 pdb-0">
        <b-field :label="$t('listeContrat.filtre.motifNonRenouvellement')">
          <qd-taginput
            v-model="newCritereRecherche.motifNonRenouvellement"
            type="is-primary">
          </qd-taginput>
        </b-field>

      </div>
    </div>
    <div class="column is-12 border-pied pdt-0 hauteur-bas-brief-filtre">
      <button class="button mgl-10px mgt-10px is-addOrEdit has-text-white"
              @click="appliquerCritere()">
        {{ $t('listeContrat.filtre.actions.appliquer') }}
      </button>

      <button @click="viderCritere()"
              class="button border-none mgt-10px has-text-icon-more pd-10px">
        {{ $t('listeContrat.filtre.actions.reinitialiser') }}
      </button>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import debounce from 'lodash/debounce';
import cloneDeep from 'lodash/cloneDeep';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import messageErreur from '@/services/general/messageErreur';
import { getAll } from '@/api/tiers';
import {
  TIERS_SOUS_TYPE_BAILLEUR_CONCESSION,
  TIERS_SOUS_TYPE_BAILLEUR_PRIVE,
  TIERS_SOUS_TYPE_BAILLEUR_PRO, TIERS_TYPE_FOURNISSEUR,
  TIERS_SOUS_TYPE_BAILLEUR_ADMINISTRATION_ET_ASSIMILEE,
  TIERS_SOUS_TYPE_DEMARCHEUR,
} from '@/configuration/tiers/tiersConf';
import { LISTE_ETAT_CONTRAT, LISTE_TYPE_CONTRAT } from '@/configuration/baux/contrat/contratConf';
import * as typesParametres from '@/store/modules/parametres-mutation-type';
import genererCritereRechercheContrat from '@/services/baux/contrat/genererCritereRechercheContrat';
import libelleTagInput from '@/components/general/tagInput/libelleTagInput';
import agenceTagInput from '@/components/general/tagInput/agenceTagInput';
import userTagInput from '@/components/general/tagInput/userTagInput';
import queryFournisseurTagInput from '@/components/general/tagInput/queryFournisseurTagInput';
import secteurTagInput from '@/components/commun/secteur/secteurTagInput';
import { PATRIMOINE } from '@/configuration/parametrage/secteurConf';
import getSecteursIdByUser, { getSecteursByIds } from '@/services/commun/secteur/getSecteurs';
import { PARAMETRES_INTERNE_KEYS } from '@/store/modules/parametres-mutation-type';
import { LISTE_ETAT_RENOUVELLEMENT } from '@/configuration/devisConf';

const Parametres = createNamespacedHelpers('parametres');
const Societe = createNamespacedHelpers('societe');

export default {
  data() {
    return {
      errors: [],
      hasError: false,
      newCritereRecherche: null,
      bailleurSelected: [],
      filteredBailleur: [],
      motifSelected: [],
      motifTags: [],
      isFetching: false,
      constantes: {
        LISTE_ETAT_CONTRAT,
        LISTE_TYPE_CONTRAT,
        TIERS_SOUS_TYPE_DEMARCHEUR,
        PATRIMOINE,
        LISTE_ETAT_RENOUVELLEMENT,
      },
      etatContratSelected: [],
      etatRenouvellementSelected: [],
      typeContratSelected: [],
      listeNatureBase: [],
      natureSelected: [],
      natureTags: null,
      responsableBailSelected: [],
      listeResponsablesBail: [],
      tiersDemarcheurSelected: [],
      secteurCurrentUser: [],
      secteursSelected: [],
    };
  },
  props: {
    critereRecherche: {
      type: Object,
      required: true,
    },
    hideBailleur: {
      required: false,
      default: true,
      type: Boolean,
    },
  },
  components: {
    libelleTagInput,
    agenceTagInput,
    errorMsgComponent,
    userTagInput,
    queryFournisseurTagInput,
    secteurTagInput,
  },
  methods: {
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
      loadParametreUtilisateur: 'loadParametreUtilisateur',
      loadParametresInterne: 'loadParametresInterne',
    }),
    getNatureTag() {
      this.natureTags = this.listeNatureBase.filter((nature) => {
        return !this.natureSelected.map(a => a.id).includes(nature.id);
      });
    },
    getMotifTag() {
      this.motifTags = this.listeMotifBase.filter((nature) => {
        return !this.motifSelected.map(a => a.id).includes(nature.id);
      });
    },
    getFilteredMotifTags(text) {
      this.getMotifTag();
      this.motifTags = this.motifTags.filter((motif) => {
        return motif.libelle.toLowerCase().indexOf(text.toLowerCase()) >= 0;
      });
    },
    getFilteredNatureTags(text) {
      this.getNatureTag();
      this.natureTags = this.natureTags.filter((nature) => {
        return nature.libelle.toLowerCase().indexOf(text.toLowerCase()) >= 0;
      });
    },
    getFilteredBailleur: debounce(async function getAfficheur(search) {
      this.filteredBailleur = [];
      if (!search) return;
      this.isFetching = true;
      try {
        const bailleur = (await getAll(
          {
            query: {
              auto: search,
              sousType: [
                TIERS_SOUS_TYPE_BAILLEUR_PRO,
                TIERS_SOUS_TYPE_BAILLEUR_CONCESSION,
                TIERS_SOUS_TYPE_BAILLEUR_PRIVE,
                TIERS_SOUS_TYPE_BAILLEUR_ADMINISTRATION_ET_ASSIMILEE,
              ],
              type: TIERS_TYPE_FOURNISSEUR,
              societeId: this.societeActiveId,
              archive: false,
            },
          },
        )).data.result.items;
        this.filteredBailleur = bailleur.filter((bailleur) => {
          return !this.bailleurSelected.map(
            bailleurSelected => bailleurSelected.id,
          ).includes(bailleur.id);
        });
        this.isFetching = false;
      } catch (e) {
        this.isFetching = false;
        messageErreur(this.$i18n);
        throw (e);
      }
    }, 300),
    closeErrorMsg() {
      this.errors = [];
      this.hasError = false;
    },
    appliquerCritere() {
      this.newCritereRecherche.tiersId = this.bailleurSelected;
      this.newCritereRecherche.etat = this.etatContratSelected.map(el => { return el.code; });
      this.newCritereRecherche.etatRenouvellement = this.etatRenouvellementSelected
        .map(el => { return el.code; });
      this.newCritereRecherche.naturesId = this.natureSelected.map(el => { return el.id; });
      this.newCritereRecherche.contratType = this.typeContratSelected.map(el => {
        return el.code;
      });
      this.newCritereRecherche.responsableBailIds = this.responsableBailSelected.map((r) => {
        return r.id;
      });
      this.newCritereRecherche.demarcheurIds = this.tiersDemarcheurSelected;
      this.newCritereRecherche.motifsBlocagesId = this.motifSelected.map(el => { return el.id; });
      if (this.moduleSecteurActive) {
        this.newCritereRecherche.secteurIds = this.secteursSelected.map(e => e.id);
      }
      this.$emit('recherche', this.newCritereRecherche);
    },
    viderCritere() {
      this.newCritereRecherche = cloneDeep(genererCritereRechercheContrat());
      if (!this.hideBailleur) {
        this.bailleurSelected = [];
      }
      this.responsableBailSelected = [];
      this.tiersDemarcheurSelected = [];
      this.motifSelected = [];
      this.initializeAutoComplete();
      this.secteursSelected = this.secteurCurrentUser;
    },
    initializeAutoComplete() {
      if (this.newCritereRecherche.etat) {
        this.etatContratSelected = this.constantes.LISTE_ETAT_CONTRAT.filter((c) => {
          return this.newCritereRecherche.etat.includes(c.code);
        });
      }
      if (this.newCritereRecherche.etatRenouvellement) {
        this.etatRenouvellementSelected = this.constantes.LISTE_ETAT_RENOUVELLEMENT.filter((c) => {
          return this.newCritereRecherche.etatRenouvellement.includes(c.code);
        });
      }
      if (this.newCritereRecherche.naturesId) {
        this.natureSelected = this.listeNatureBase.filter((c) => {
          return this.newCritereRecherche.naturesId.includes(c.id);
        });
      }
      this.getNatureTag();

      if (this.newCritereRecherche.contratType) {
        this.typeContratSelected = this.constantes.LISTE_TYPE_CONTRAT.filter((c) => {
          return this.newCritereRecherche.contratType.includes(c.code);
        });
      }
      this.tiersDemarcheurSelected = this.newCritereRecherche.demarcheurIds;
    },
    async initializeFiltre() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        this.newCritereRecherche = cloneDeep(this.critereRecherche);
        await this.loadParametres([
          typesParametres.PARAMETRES_KEYS.contratNature,
          typesParametres.PARAMETRES_KEYS.motifBlocage,
        ]);
        await this.loadParametresInterne([
          PARAMETRES_INTERNE_KEYS.moduleSecteur.key,
        ]);
        await this.loadParametreUtilisateur();

        this.secteursSelected = await getSecteursByIds(
          this.critereRecherche.secteurIds, PATRIMOINE);
        this.secteurCurrentUser = await getSecteursIdByUser(PATRIMOINE, true);
        if (this.secteurCurrentUser.length) this.secteursSelected = this.secteurCurrentUser;
        this.newCritereRecherche.secteurIds = this.secteursSelected.map(e => e.id);

        this.bailleurSelected = this.newCritereRecherche.tiersId;
        this.listeNatureBase = this.contratNature;
        this.listeResponsablesBail = this.parametre(typesParametres.PARAMETRES_KEYS.utilisateur)
          .filter((user) => user.responsableBail && user.actif);
        this.motifTags = this.motifBlocage;
        this.responsableBailSelected = this.listeResponsablesBail.filter((r) => {
          return this.newCritereRecherche.responsableBailIds.includes(r.id);
        });
        this.listeMotifBase = this.motifBlocage;
        if (this.critereRecherche.motifsBlocagesId) {
          this.motifSelected = this.listeMotifBase.filter((c) => {
            return this.critereRecherche.motifsBlocagesId.includes(c.id);
          });
        }
        this.getMotifTag();
        this.initializeAutoComplete();
        loadingComponent.close();
      } catch (e) {
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw e;
      }
    },
  },
  computed: {
    ...Parametres.mapGetters({
      parametre: 'parametre',
      parametresInterne: 'parametresInterne',
    }),
    ...Societe.mapGetters({
      agencesSelectionnees: 'agenceActive',
      societeActiveId: 'societeActiveId',
    }),
    contratNature() {
      return this.parametre(typesParametres.PARAMETRES_KEYS.contratNature);
    },
    motifBlocage() {
      return this.parametre(typesParametres.PARAMETRES_KEYS.motifBlocage)
        .filter(motif => motif.actif);
    },
    moduleSecteurActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.moduleSecteur.key);
    },
  },
  mounted() {
    this.initializeFiltre();
  },
};
</script>

<style scoped>

</style>
